import { AppContextType } from '../UISurfaces/AppContext/AppContext';
import { isIE } from './browserUtils';

export const ribbonExperiments = {
  renderInitiallyEnabledRibbonIsEnabled: 'RenderInitiallyEnabledRibbonIsEnabled',
  updatedTellMePlaceholderIsEnabled: 'UpdatedTellMePlaceholderIsEnabled',
  multilineRibbonIsEnabled: 'ReactMultilineRibbonIsEnabled',
  shadowRenderingIsEnabled: 'ShadowRenderingIsEnabled',
  taskPaneResizingIsEnabled: 'TaskPaneResizingIsEnabled',
  areControlsConnectedToStore: 'AreControlsConnectedToStore',
  areMenusConnectedToStore: 'AreMenusConnectedToStore',
  activateComboAndSpinControlOnEnter: 'ActivateComboAndSpinMenuItemOnEnterIsEnabled',
  batchScaleDataInRibbon: 'BatchScaleDataInRibbon',
  shyRibbonIsEnabled: 'ShyRibbonIsEnabled',
  shyRibbonIsEnabledFG: 'Microsoft.Office.SharedOnline.ShyRibbonIsEnabled',
  ribbonCachedScalingIsEnabled: 'ReactRibbonCachedScalingIsEnabled',
  ribbonPaddlesIsEnabled: 'RibbonPaddlesIsEnabled',
  reactRibbonPaddlesIsEnabled: 'ReactRibbonPaddlesIsEnabled',
  reactRibbonPaddlesIsEnabledFG: 'Microsoft.Office.SharedOnline.ReactRibbonPaddlesIsEnabled',
  taskPaneBackgroundRefreshIsEnabled: 'TaskPaneBackgroundRefreshIsEnabled',
  quickRibbonScalingIsEnabled: 'QuickRibbonScalingIsEnabled',
  delayRibbonAnimationComponents: 'DelayAnimationComponentsIsEnabled',
  ribbonRenderBootThrottlingIsEnabled: 'RibbonRenderBootThrottlingIsEnabled',
  delayTabHeaderCalculationsIsEnabled: 'DelayTabHeaderCalculationsIsEnabled',
  fastDisabledRibbonControlGroupsIsEnabled: 'FastDisabledRibbonControlGroupsIsEnabled',
  ribbonUseV8Button: 'Microsoft.Office.SharedOnline.FluentV8ButtonIsEnabled',
  ribbonUseV8MenuButton: 'Microsoft.Office.SharedOnline.FluentV8MenuButtonIsEnabled',
  reactSharedHeaderIsEnabled: 'ReactSharedHeaderIsEnabled',
  hideHeaderEmbedded: 'HideHeaderEmbedded',
  delayRenderTooltipsIsEnabled: 'DelayRenderTooltipsIsEnabled',
  disableRibbonAnimationComponents: 'DisableAnimationComponentsIsEnabled',
  delayInstallAddInIsEnabled: 'DelayInstallAddInIsEnabled',
  modernUxExperimentOneIsEnabled: 'ModernUxExperimentOneIsEnabled',
  buildTimeRibbonScalingIsEnabled: 'BuildTimeRibbonScalingIsEnabled',
  tooltipsTargetOverflowSetItemEnabled: 'TooltipsTargetOverflowSetItemEnabled',
  disableColorPickerFancyTooltips: 'DisableColorPickerFancyTooltips',
  preventExcessColorPickerHandlersIsEnabled: 'PreventExcessColorPickerHandlersIsEnabled',
  batchTopBarScaleDataInRibbon: 'BatchTopBarScaleDataInRibbon',
  suppressCalloutWithOccludedTargetIsEnabled: 'SuppressCalloutWithOccludedTargetIsEnabled',
  buildTimeRibbonScalingMLRIsEnabled: 'Microsoft.Office.SharedOnline.BuildTimeRibbonScalingMLRIsEnabled',
  areControlsConnectedToStoreFG: 'Microsoft.Office.SharedOnline.AreControlsConnectedToStore',
  calloutCoordinatorIsEnabled: 'Microsoft.Office.SharedOnline.calloutCoordinatorIsEnabled',
};

export const checkExperiment = (context: AppContextType, feature: string) => {
  return context.isExperimentalFeatureEnabled && context.isExperimentalFeatureEnabled(feature);
};

export const isShyRibbonEnabled = (context: AppContextType) => {
  return (
    context.isExperimentalFeatureEnabled &&
    (context.isExperimentalFeatureEnabled(ribbonExperiments.shyRibbonIsEnabled) ||
      context.isExperimentalFeatureEnabled(ribbonExperiments.shyRibbonIsEnabledFG)) &&
    context.isExperimentalFeatureEnabled(ribbonExperiments.reactSharedHeaderIsEnabled) &&
    !context.isExperimentalFeatureEnabled(ribbonExperiments.hideHeaderEmbedded) &&
    !isIE()
  );
};
